import React from 'react';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F3F6F9] p-8">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 bg-[#FEE2E2] rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-7 h-7 text-[#C23934]" />
            </div>
            <h2 className="text-[20px] font-semibold text-[#181818] mb-2">Something went wrong</h2>
            <p className="text-[13px] text-[#5F6B7A] mb-5">
              This page encountered an unexpected error. Please refresh the page or navigate home.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-[#0176D3] text-white rounded text-[13px] font-medium hover:bg-[#014486] transition-colors"
              >
                Refresh Page
              </button>
              <button
                onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}
                className="px-4 py-2 bg-white border border-[#D8DDE6] text-[#181818] rounded text-[13px] font-medium hover:bg-[#F3F6F9] transition-colors"
              >
                Go Home
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="mt-5 text-left bg-white border border-[#D8DDE6] rounded p-3 text-[11px] text-[#C23934] overflow-auto max-h-40">
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
